import api from "../../API/apiConfig";

export const getTagDetail = async (id) => {
  return await api.get(`/tags/detail/${id}`);
};

export const getTagList = async () => {
  return await api.get(`/tags/list-all`);
};

export const updateTag = async (id, name) => {
  return await api.put(`/tags/update/${id}`, {name});
};

export const updateAssignTag = async (recordId, tagId, type) => {
  return await api.post("/tags/update-assign", {
    recordId: Array.isArray(recordId) ? recordId : [recordId],
    tagId: Array.isArray(tagId) ? tagId : [tagId],
    type: type,
  });
};

export const deleteRecord = async (recordId, recordType) => {
  return await api.post(`/tags/delete-record`, {recordId}, {recordType});
};

export const addAssignTag = async (recordId, tagId, type) => {
  return await api.post("/tags/assign", {
    recordId: Array.isArray(recordId) ? recordId : [recordId],
    tagId: Array.isArray(tagId) ? tagId : [tagId],
    type: type,
  });
};

export const addTag = async (tag) => {
  return await api.post(`/tags/add`, tag);
};

export const listAllTag = async () => {
  return await api.get(`/tags/list-all`);
};

export const deleteTag = async (id) => {
  return await api.delete(`/tags/delete/${id}`);
};

export const deleteAssignTag = async (recordId, tagId, type) => {
  return await api.delete("/tags/delete-assigntag", {
    recordId: Array.isArray(recordId) ? recordId : [recordId],
    tagId: Array.isArray(tagId) ? tagId : [tagId],
    type: type,
  });
};

export const tagAssignMember = async(tagId, memberIds) => {
  return await api.post("/tags/assign-member", {tagId, memberIds});
};